"use client";

import { XMarkIcon, PhoneIcon, EnvelopeIcon } from "@heroicons/react/20/solid";

import { useState } from "react";

export default function Banner() {
  const [isBannerOpen, setIsBannerOpen] = useState(true);

  const closeBanner = () => {
    setIsBannerOpen(false);
  };

  // Phone and email click tracking is handled globally by ContactTracker (a
  // delegated tel:/mailto: listener) so every contact link on the site fires
  // one consistent event. No per-component handlers needed here.

  if (!isBannerOpen) {
    return null; // Return null to hide the banner when it's closed
  }

  return (
    <div className="sticky inset-x-0 bottom-0  z-40  -mt-1 pt-4  isolate flex items-center gap-x-6 text-white overflow-hidden bg-yellow-600 dark:bg-yellow-600 px-2 py-2.5 sm:px-1.5 before:flex-1">
      <div
        className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        aria-hidden="true"
      >
        <div
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#000000] to-[blue] opacity-30"
          style={{
            clipPath:
              "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
          }}
        />
      </div>
      <div
        className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        aria-hidden="true"
      >
        <div
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#000000] to-[blue] opacity-30"
          style={{
            clipPath:
              "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
          }}
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <p className=" sm:flex text-sm leading-6 hidden ">
          <svg
            viewBox="0 0 2 2"
            className="mx-2 inline h-0.5 w-0.5 fill-current"
            aria-hidden="true"
          ></svg>
          Same Day & Priority Appraisals Available
        </p>
        <a
          href="tel:416-450-2336"
          className="group flex justify-evenly px-2 align-middle text-left sm:text-center  sm:w-fit   rounded-lg bg-black shadow-inner sm:px-2.5  py-1 text-sm font-semibold text-white hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 transition-all duration-300"
          title="(416) 450-2336"
        >
          <span className=" flex  items-center  transition-opacity duration-300 pr-2 sm:pr-0 sm:border-none">
            <PhoneIcon
              className="  h-6 w-6 font-bold  p-1 "
              aria-hidden="true"
            />
            <span className="px-1 hidden sm:flex font-semibold">
              (416) 450-2336 • Speak With Our Designated Home Appraiser
            </span>
          </span>
          <p className="sm:hidden text-sm text-left py-1 pr-1 align-middle center sm:pr-0 tracking-tighter ">
            Speak With Our Designated Appraiser
          </p>
        </a>{" "}
        <div className="relative hidden  sm:flex group ">
          <a
            href="mailto:info@alphaappraisals.ca"
            className="flex-none rounded-lg bg-blue-500  px-3.5 py-1 text-sm font-semibold text-white  hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
          >
            <EnvelopeIcon className=" h-5 w-5" aria-hidden="true" />
          </a>
          <span className="absolute left-0 bottom-0 py-1  w-52 bg-blue-500 text-white text-center rounded  px-4 invisible group-hover:visible">
            info@alphaappraisals.ca
          </span>
        </div>
      </div>
      <div className="flex flex-1 justify-end">
        <button
          type="button"
          className="  focus-visible:outline-offset-[-4px]"
          onClick={closeBanner}
        >
          <span className="sr-only">X</span>
          <XMarkIcon className="h-5 w-5 " aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
